'use client';

import { useEffect, useState } from 'react';
import { usePathname } from '@/i18n/navigation';
import {
  REGISTRATION_FLOW_COOKIE,
  REGISTRATION_MAX_STEP_CHANGED_EVENT,
  parseRegistrationMaxStep,
} from '@/lib/registrationFlowCookie';

function readMaxFromCookie(): number {
  if (typeof document === 'undefined') return 1;
  const raw = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${REGISTRATION_FLOW_COOKIE}=`))
    ?.split('=')[1];
  return parseRegistrationMaxStep(raw);
}

/** Текущий max-шаг воронки из cookie (обновляется при смене пути и при возврате фокуса на вкладку). */
export function useRegistrationMaxStep(): number {
  const pathname = usePathname();
  const [max, setMax] = useState(1);

  useEffect(() => {
    setMax(readMaxFromCookie());
  }, [pathname]);

  useEffect(() => {
    const onFocus = () => setMax(readMaxFromCookie());
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, []);

  useEffect(() => {
    const onCookieBump = () => setMax(readMaxFromCookie());
    window.addEventListener(REGISTRATION_MAX_STEP_CHANGED_EVENT, onCookieBump);
    return () => window.removeEventListener(REGISTRATION_MAX_STEP_CHANGED_EVENT, onCookieBump);
  }, []);

  return max;
}
